import { InvitePreviewTemplate } from '../interfaces';

export const getMockedCompaniesInviteEmailTemplate = (
  companyName?: string,
  companyId?: string,
  fundName?: string,
  pricesAndClasses?: string,
  sharesToPurchase?: string,
): InvitePreviewTemplate => ({
  content: '',
  // eslint-disable-next-line
  preview: `<!doctype html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta name="color-scheme" content="light dark">
        <meta name="supported-color-schemes" content="light dark">
    </head>
    <body style="margin: 0;padding: 0;font-family: Arial, sans-serif; background: #f8f8f8">
    <table style="width: 100%; background: #080E36; min-height: 83px;" role="presentation">
      <tr>
        <td align="center">
          <img
            style="height: 35px;"
            src="https://userimg-assets-eu.customeriomail.com/images/client-env-171084/1731670142947_planD%20logo%20big_01JCQSAW42XYQP6D6QM0X9WQ0A.png"
            alt="Logo"/>
        </td>
      </tr>
    </table>
    <div style="max-width: 650px; background-color: #ffffff; border: none; font-family: Arial, sans-serif; margin:0 auto; padding: 5px 20px;">
        <div style="width: 100%; text-align: center; border: 2px solid #000000; padding: 20px 10px; margin-top: 10px; color: black;">
            <b>Don’t invest unless you’re prepared to lose all the money you invest. This is a high-risk investment and you are unlikely to be protected if something goes wrong. </b> 
            </br>
            <b><a href="https://pland.co/risksummary">Take two minutes to learn more</a>.</b>
    </div>
    </br>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    To: ${companyName} Shareholders,
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    RE: Opportunity to exit and potential loss crystallisation.
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    <a href="https://pland.co">planD</a> advise a fund (<a href="https://www.daxia.co.uk">${fundName}</a>) which acquires shares in companies on an exchange of
    shares basis - exit via diversification™ (consideration in the transaction would be shares in
    Daxia, a diversified fund).
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    They would be willing to purchase up to ${sharesToPurchase} shares in ${companyName}, on
    a first come, first served basis.
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
         ${pricesAndClasses}
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    For those who are interested in selling your shares please click on this link to register on the
    planD platform where you can access the information memorandum once you have started
    the short digital workflow:
    </p>

    <table cellspacing="0" cellpadding="0" style="margin: 40px auto 30px;">
        <tbody><tr>
            <td align="center" style="background-color: #31D3C8; padding: 16px 24px; border-radius: 32px;">
            <a href="" target="_blank" style="color: #080E36; text-decoration: none; font-size:16px; font-weight:700; line-height:24px;">
                Register
                </a><a href="https://pland.co/sign-up/?company_id=` +
    companyId +
    `&user_type=investor&flow=cse">
                    <img style="vertical-align:middle; padding-left:8px;" src="https://userimg-assets-eu.customeriomail.com/images/client-env-171084/1731671926536_arrow_forward_01JCQV1B9AFNEB3EBCRFG78042.png" alt="arrow" border="0">
                </a>
            </td>
        </tr>
        </tbody></table>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    If you have any questions, you can email the planD team at <a href="mailto:support@pland.co"> support@pland.co </a>
    or book a meeting with them <a href="https://meetings.hubspot.com/lawrence94">here</a>.
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    Fees apply - the greater of £150 or 2% of the initial investment value. For the purpose of
    clarity, if you invested £10,000 the fee would be £200. If you invested less than £7,500, the
    fee would be £150.
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    The availability of any tax relief depends on the individual circumstances of each investor and
    of the company concerned - you should always obtain independent tax advice.
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    ---------
    </p>
    <div style="font-style: italic">
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    Video Explainer: More information on the planD process can be found in the explainer video <a href="https://vimeo.com/711789041">here</a>.
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    Daxia: Daxia is a Fund whose sole purpose is to acquire stakes in predominantly underperforming (S)EIS companies in exchange for Shares in itself. This cashless transaction provides the Investor with exposure to a diversified portfolio thereby increasing the chances of liquidity events.
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    Tax: Provided the Investor's Target Shares are eligible, the proposed sale of those Target
    Shares to the Fund constitutes a share disposal for CGT purposes and any loss arising shouldbe available for loss relief under s131 ITA 2007. Furthermore, s684 ITA 2007 should not apply given that there would be no income tax advantage being sought or obtained as a result of
    entering into the proposed transactions.
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    FIFO (first in, first out): The ordinary share identification rules do not apply to shares that have attracted EIS relief. There is no pooling of these shares and other matching rules do not apply.
    Instead the Income Tax rules in ITA07/S246(2) apply. Disposals are identified first against the earliest acquisition.
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    Selling EIS Shares within 3 years of issue: It is our understanding that EIS shares that are sold at a loss within 3 years of issue are subject to partial clawback of the upfront tax relief.
    The relief withdrawn is 30% of the value of the sales proceeds.
    </p>
    </div>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    This is a financial promotion for the purposes of Section 21 of FSMA. It is issued by GetplanD Ltd FRN: 945131, an Appointed Representative of Enterprise Investment Partners LLP FRN:604439, an AIFM as defined by the AIFMD, who have approved it, on 15/03/24, and who are authorised by the FCA. This is not an offer to buy or sell securities and does not constitute a Direct Offer Financial Promotion. Applications for investment may only be made on the basis of the relevant [Information Memorandum and application form, copies of which are available on request. No reliance is to be placed on the information contained in this document in making such an application. Information herein is not intended to, nor should be taken to, constitute advice. This material is directed only at persons in the UK.
    </p>
    <p style="color: #74726F; line-height: 24px; margin-bottom: 28px; font-size: 16px; font-weight: 400;">
    GetplanD Ltd source investments in unquoted securities, which are classified by the FCA as a Non-Readily Realisable Security (NRRS). As such, these products may only be marketed to limited categories of investors relating to knowledge, experience or financial situation. Investors should not invest unless they are prepared to lose all the money they invest. This is a high risk investment. Past performance is not a reliable indicator of future results. Investment is of a long-term and illiquid nature. It can be difficult to value or sell unquoted investments. Any described tax advantages associated with investing are based on current legislation, are subject to change, and depend on the individual circumstances of each investor.
    </p>
    <div style="width: 100%; text-align: center; font-style: italic;">
    <p style="color: #74726F; line-height: 15px; font-size: 13px; font-weight: 400;">
    GetplanD Ltd (FRN 945131) is an Appointed Representative of Enterprise Investment Partners LLP (FRN 604439), a firm which is authorised and regulated by the Financial Conduct Authority.
    </p>
    <p style="color: #74726F; line-height: 15px; font-size: 13px; font-weight: 400;">
    Get planD Ltd is a company registered in England and Wales with a Company Registration No: 12901503
    </p>
     <p style="color: #74726F; line-height: 15px; font-size: 13px; font-weight: 400;">
    Registered office address: TOG 20 Eastbourne Terrace, London, United Kingdom, W2 6LG
    </p>
    </div>
    </div>
    <div class="container" style="max-width:650px;background-color:#ffffff;border:none;font-family:Arial,sans-serif; margin:0 auto;">
    </div>
    </body>
    </html>`,
});
